import React, { useCallback, useMemo, useState } from 'react';
import { ResultItem, ResultsList, SearchContainer, SearchDiv, SearchInput } from './styles';

import SearchIcon from '@mui/icons-material/Search';
import styled from 'styled-components';
import { debounce } from '@mui/material';

interface ContentIndex {
  url: string;
  title?: string;
  content: string;
}

interface SearchProps {
  data: ContentIndex[];
}
const SearchIconStyled = styled(SearchIcon)`
  margin-left: -40px;
  color: white;
  cursor: pointer;
  margin-top: 7px;
`;

const Search: React.FC<SearchProps> = ({ data }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<ContentIndex[]>([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = useCallback(
    debounce((searchTerm: string) => {
      if (searchTerm.length > 0) {
        const filteredResults = data.filter(
          (item) =>
            (item.content?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (item.title?.toLowerCase() || '').includes(searchTerm.toLowerCase())
        );
        setResults(filteredResults);
      } else {
        setResults([]);
      }
    }, 300),
    [data]
  );

  const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value;
    setQuery(searchTerm);
    handleSearch(searchTerm);
  }, [handleSearch]);

  const handleClick = useCallback(() => {
    setShowResults((prev) => !prev);
  }, []);

  const handleResultClick = useCallback(() => {
    setResults([]);
    setShowResults(false);
  }, []);

  const memoizedResults = useMemo(() => results, [results]);

  return (
    <SearchContainer>
      <SearchDiv>
        <SearchInput
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder="Digite sua busca..."
        />
        <SearchIconStyled onClick={handleClick} />
      </SearchDiv>
      <ResultsList>
        {showResults &&
          memoizedResults.map((result) => (
            <ResultItem key={result.url}>
              <a href={result.url} onClick={handleResultClick}>
                <h3>{result.title || 'Sem título'}</h3>
                <p>{result.content}</p>
              </a>
            </ResultItem>
          ))}
      </ResultsList>
    </SearchContainer>
  );
};

export default React.memo(Search);
